import firebase from '../../services/firebase';
import ViewData from './views.js';

// Main/Global state for the platform.
const state = {

  // Brands
  brands: undefined,
  currentUser: undefined,

  // Loading Overlay visiblity and message
  loadingOverlayVisible: undefined,
  loadingOverlayMessage: '',

  // Snackbar Messages
  snackbarVisible: undefined,
  snackbarMessage: undefined,
  snackbarState: 'success',

  // Mobile menu
  mobileMenuVisible: false,

  // View data
  currentView: undefined,
  defaultView: {
    name: 'Attach',
    route: '/',
    slug: 'attach',
  },
  activeView: undefined,
  defaultSelfServeView: '/dashboard',
  views: ViewData.views,
  viewSubnav: ViewData.subnav,

  // Feature Flags
  featureFlags: [],
  showNewSelect: false,
  showNewBrandSelector: false,
  showNewExplorerMessages: false,

  // generic loading
  isLoading: false,

  // NavBar
  marginBehindNavBar: 202,
};

const mutations = {
  setBrands(state, brands) {
    state.brands = brands;
  },
  toggleMobileMenu(state) {
    state.mobileMenuVisible = !state.mobileMenuVisible;
  },
  updateCurrentUser(state, user) {
    state.currentUser = user;
  },
  showSnackbar(state, message) {
    state.snackbarVisible = true;
    state.snackbarMessage = message;
  },
  showLoadingMessage(state, message) {
    state.loadingOverlayVisible = true;
    state.loadingOverlayMessage = message;
  },
  hideLoadingMessage() {
    state.loadingOverlayVisible = false;
  },
  hideSnackbar() {
    state.snackbarVisible = false;
  },
  setSnackbarState(state, sbState) {
    sbState = sbState || 'success';
    state.snackbarState = sbState;
  },
  updateCurrentView(state, view) {
    state.views.map((viewObj) => {
      if (viewObj.name == view) state.currentView = viewObj;
    });
  },
  updateActiveView(state, view) {
    state.activeView = view;
  },
  updateFeatureFlags(state, flags) {
    const activeFlags = flags.filter(flag => flag.enabled);

    state.featureFlags = activeFlags;
    state.showNewSelect = activeFlags.find(flag => flag.name === 'release-new-select');
    state.showNewBrandSelector = activeFlags.find(flag => flag.name === 'release-new-brand-selector');
    state.showNewExplorerMessages = activeFlags.find(flag => {
      return flag.name === 'release-new-explorer-messages';
    });
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setMarginBehindNavBar(state, marginBehindNavBar) {
    state.marginBehindNavBar = marginBehindNavBar;
  },
};

const actions = {
  setAllBrandData: async ({ commit }, token) => {
    const brands = await firebase.getAllActiveBrands(token);

    commit('setBrands', brands);
  },
  setFeatureFlags: ({ commit }, flags) => {
    commit('updateFeatureFlags', flags);
  },
};

const module = {
  state,
  mutations,
  actions,
};

export default module;
